import { Component, Input, OnDestroy, OnInit, ViewChild, ChangeDetectorRef  } from '@angular/core';
import { Subscription } from 'rxjs';
import { FacilityExportFileStatusComponent } from '../facility-export-file-status/facility-export-file-status.component';
import { FacilityExportActivityLogComponent } from '../facility-export-activity-log/facility-export-activity-log.component';
import { FacilityExportService } from '../../services/facility-export.service';
import { LoggingMessageService } from '../../services/logging-message.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-facility-export-history',
  templateUrl: './facility-export-history.component.html',
  styleUrl: './facility-export-history.component.css'
})
export class FacilityExportHistoryComponent implements OnInit, OnDestroy{
  @Input() hospid: number;
  @ViewChild(FacilityExportActivityLogComponent) activity: FacilityExportActivityLogComponent;
  @ViewChild (FacilityExportFileStatusComponent) fileStatus: FacilityExportFileStatusComponent;
  facilityExportActivityLog: any[] = []; // Data for activityLog tab
  facilityExportRequestedFiles: any[] = []; // Data for file-status tab
  isAdmin: boolean = false; // Needed for tab ActivityLog visibility
  public showTab: boolean = true;
  private $subscriptions: Subscription = new Subscription();
  loading: boolean = false; // Add loading variable: track the loading state: Set loading to true before making the API call and set it to false after the data is loaded.

  constructor(private dataService: FacilityExportService, private cdr: ChangeDetectorRef, private logger: LoggingMessageService, private authService: AuthService) { }

  ngOnInit() {
    this.loadData();
  }
  
  private loadData() {
    if (!this.hospid) return;

    this.loading = true; // Set loading to true before API call
    this.cdr.detectChanges(); // Ensure loading state is reflected in the view
    
    // Introduce a delay before making the API call
  //setTimeout(() => {
    const $exportSubscription = this.dataService.getFacilityExportActivity(this.hospid)
      .subscribe({
        next: (res: any) => {
          this.facilityExportActivityLog = res.facilityExportActivityLog; // Data for activityLog tab
          this.facilityExportRequestedFiles = res.facilityExportRequestedFiles; // Data for file-status tab       
          this.isAdmin = res.isAdmin;          
          this.loading = false; // Set loading to false after data is loaded
          this.cdr.detectChanges(); // Force change detection
        },
        error: (error) => {
          console.error('Error loading facility export data:', error);
          this.loading = false; // Set loading to false in case of error
          this.cdr.detectChanges();
        }
      });
    this.$subscriptions.add($exportSubscription);
  //},2000); // 2 second delay
    this.postWindowMessage();
  }

  onRefreshClicked() {
    this.refreshHistory();
  }

  refreshHistory() {
    this.loadData();
  }

  checkActivityTabStatus(status: boolean) {
    this.showTab = status;
  }

  private postWindowMessage() {
    setTimeout(() => {
      this.logger.info('facility-export-history.component', 'postWindowMessage', this.authService.SelectedSubscription, this.authService.AvailableSubscriptionsString, `facilityID=${this.hospid}`, '');
      window.parent.postMessage('indicatorfactoryaction:', '*');
    }, 0);
  }

  private Unsubscribe() {
    if (this.$subscriptions) {
      this.$subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.Unsubscribe();
  }
}
